module.exports = __webpack_public_path__ + "static/media/s2.bb271192.png";